import { render, staticRenderFns } from "./EntitiesTabPane.vue?vue&type=template&id=2c10b66d"
import script from "./EntitiesTabPane.vue?vue&type=script&lang=js"
export * from "./EntitiesTabPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports